import axios from 'axios';

import refreshScrollAndTriggers from '../helpers/refreshScrollTriggers';
import { CLASSES } from '../helpers/consts';

export default () => {
		const isBlogPage = document.querySelectorAll('.js-blog-filter-section').length > 0;
    const worksWrapper = document.querySelector('#works-wrapper'),
        worksArchivesWrapper = document.querySelector('#works-archives-wrapper'),
        postsWrapper = document.querySelector('#posts-wrapper');


		const toggleColorClass = () => {
			if(isBlogPage) document.body.classList.toggle('is-load-more-light');
		}
		
		const resetColorClass = () => {
			if(isBlogPage) document.body.classList.remove('is-load-more-light');
		}
		const addHiddenLoadMoreClass = () => {
			document.body.classList.add('is-load-more-hidden');
		}
		const removeHiddenLoadMoreClass = () => {
			document.body.classList.remove('is-load-more-hidden');
		}


		const toggleAllFilterView = (btn) => {
			const filterWrapper = document.querySelector('.js-filter-wrapper');
			const isAllBtn = btn.classList.contains('js-filter-btn-all');

			if(isAllBtn) {
				filterWrapper.classList.remove('is-all-view')
			} else {
				filterWrapper.classList.add('is-all-view')
			}
		}
		const setAllFilterView = () => {
			const filterWrapper = document.querySelector('.js-filter-wrapper');
			const btn = filterWrapper.querySelector('.js-filter-btn-all');
			const isAllBtn = btn.classList.contains(CLASSES.active);

			if(!filterWrapper || !btn) return;
			if(isAllBtn) {
				filterWrapper.classList.remove('is-all-view')
			} else {
				filterWrapper.classList.add('is-all-view')
			}
		}

    let pageNumber = 1;

    if (postsWrapper) {
        const catFilter = document.querySelector('#posts-categories-filter'),
            postsList = document.querySelector('#posts-list'),
            loadMoreButton = document.querySelector('#loadMore'),
            postSearchForm = document.querySelector('#post-search');

        let catFilterButton = catFilter.querySelectorAll('.js-filter');

        catFilterButton.forEach(button => {
            button.addEventListener('click', (el) => {
                filterCPTs(el, postsList, catFilter, postsWrapper);
            });
        });

        if (loadMoreButton) {
            loadMoreButton.addEventListener('click', (el) => {
                LoadMoreCPT(loadMoreButton, postsList, postsWrapper, catFilter);
            });
        }

        if (postSearchForm) {
            searchCPT(postSearchForm, postsList, postsWrapper, loadMoreButton, catFilter);
        }
    }

    if (worksWrapper) {
			const catFilter = document.querySelector('#works-categories-filter'),
			worksList = document.querySelector('#works-list'),
			loadMoreButton = document.querySelector('#loadMore');
			let catFilterButton = catFilter.querySelectorAll('.js-filter');
			console.log(`worksWrapper`)
			setAllFilterView();
        catFilterButton.forEach(button => {
					button.addEventListener('click', (el) => {
						filterCPTs(el, worksList, catFilter, worksWrapper);
						toggleAllFilterView(el.target);
            });
        });
    }

    if (worksArchivesWrapper) {
        const catFilter = document.querySelector('#works-archives-categories-filter'),
            worksList = document.querySelector('#works-list'),
            loadMoreButton = document.querySelector('#loadMore'),
            workSearchForm = document.querySelector('#work-search');
        let catFilterButton = catFilter.querySelectorAll('.js-filter');

				setAllFilterView();
        catFilterButton.forEach(button => {
            button.addEventListener('click', (el) => {
                filterCPTs(el, worksList, catFilter, worksArchivesWrapper);
								toggleAllFilterView(el.target);
            });
        });
        if (loadMoreButton) {
            loadMoreButton.addEventListener('click', (el) => {
                LoadMoreCPT(loadMoreButton, worksList, worksArchivesWrapper, catFilter);
            });
        }
        if (workSearchForm) {
            searchCPT(workSearchForm, worksList, worksArchivesWrapper, loadMoreButton, catFilter);
        }
    }

    function searchCPT(SearchForm, wrapper, generalWrapper, loadMoreButton, filtersWrapper) {
        const postSearchField = SearchForm.querySelector('.search-input');
        const fieldWrapper = postSearchField.closest('.js-search-field');
      

        let searchQuery = '',
            clearFilters = document.querySelector('#clear-filters'),
            filterButton = filtersWrapper.querySelectorAll('.js-filter'),
            cpt = generalWrapper.getAttribute("data-cpt"),
            offset = generalWrapper.getAttribute("data-offset") ? generalWrapper.getAttribute("data-offset") : '';

        SearchForm.addEventListener('submit', function (e) {
            e.preventDefault();
        });

				if(fieldWrapper) {
					const resetBtn = fieldWrapper.querySelector('.js-search-field-reset');
					resetBtn.addEventListener('click', function (e) {
							e.preventDefault();
							postSearchField.value = '';
							fieldWrapper.classList.remove('is-active')
	
							const event = new Event('input', {
									bubbles: true,
									cancelable: true,
							});
	
							postSearchField.dispatchEvent(event);
					});
				}

        postSearchField.addEventListener('input', function (e) {
            e.preventDefault();

            searchQuery = this.value.trim();
            let data = new URLSearchParams();
            data.append('cpt', cpt);
            data.append('offset', offset);
            data.append('action', 'search_posts');
            data.append('nonce', nonce);

            filterButton.forEach(button => {
                button.classList.remove('is-active');
            });

            clearFilters.classList.add('is-active');
						setAllFilterView();

            if (searchQuery.length > 0) {
                fieldWrapper.classList.add('is-active')
            } else {
                fieldWrapper.classList.remove('is-active')
            }

            if ((searchQuery.length > 2) || (searchQuery.length === 0)) {

                generalWrapper.classList.add('loading');

                if (searchQuery.length === 0) {
                    searchQuery = '';
                    let ppp = generalWrapper.getAttribute("data-ppp") ? generalWrapper.getAttribute("data-ppp") : '';
                    data.append('ppp', ppp);

                }
                data.append('search', searchQuery);

								resetColorClass();

                axios.post(ajaxurl, data)
                    .then(function (response) {
                        wrapper.innerHTML = response.data['posts'];
                        let pages = response.data['pages'];
                        generalWrapper.classList.remove('loading');
                        generalWrapper.setAttribute('data-page', 1);
                        let pagesNum = parseInt(pages, 10);
                        if (pagesNum > pageNumber) {
                            generalWrapper.setAttribute('data-load-more', 'enabled');
														if(loadMoreButton) {
															loadMoreButton.style.display = "inline-flex";
															loadMoreButton.style.visibility = 'visible';
														}
                        } else {
                            generalWrapper.setAttribute('data-load-more', 'disabled');
														if(loadMoreButton){
															loadMoreButton.style.display = "none";
															loadMoreButton.style.visibility = 'hidden';
														}
                        }
												refreshScrollAndTriggers();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        });
    }

    function LoadMoreCPT(el, wrapper, generalWrapper, catFilter) {
        let taxId = catFilter.getAttribute("data-tax") ? catFilter.getAttribute("data-tax") : '',
            taxName = catFilter.getAttribute("data-taxonomy") ? catFilter.getAttribute("data-taxonomy") : '',
            ppp = generalWrapper.getAttribute("data-ppp") ? generalWrapper.getAttribute("data-ppp") : '',
            state = generalWrapper.getAttribute("data-state") ? generalWrapper.getAttribute("data-state") : '',
            pages = generalWrapper.getAttribute("data-pages"),
            cpt = generalWrapper.getAttribute("data-cpt"),
            offsetArchive = generalWrapper.getAttribute("data-offset") ? generalWrapper.getAttribute("data-offset") : '',
            offset = pageNumber * ppp,
            data = new URLSearchParams();

				toggleColorClass();

        data.append('action', 'posts_loadmore');
        data.append('offset', offset);
        data.append('offset_archive', offsetArchive);
        data.append('ppp', ppp);
        data.append('cpt', cpt);
        data.append('tax_id', taxId);
        data.append('taxonomy', taxName);
        data.append('state', state);

        axios.post(ajaxurl, data)
            .then(function (response) {
                pageNumber++;
                wrapper.insertAdjacentHTML('beforeend', response.data);
                let pagesNum = parseInt(pages, 10);
                if (pageNumber === pagesNum) {
                    el.style.display = "none";
                    el.style.visibility = 'hidden';
										addHiddenLoadMoreClass();
                } else {
									removeHiddenLoadMoreClass();
								}
								refreshScrollAndTriggers();
            })
            .catch(function (error) {
                console.log(error);
            });
    }

		function resetSearchField() {
			const field = document.querySelector('.js-search-field');
			if(field) {
				const input = field.querySelector('input');
				field.classList.remove('is-active');
				input.value = '';
			}
		}
    function filterCPTs(el, wrapper, filtersWrapper, generalWrapper) {

        pageNumber = 1;
        wrapper.classList.add('filtering');
        wrapper.setAttribute('data-page', 1);
        const taxonomy = filtersWrapper.getAttribute("data-taxonomy"),
            ppp = generalWrapper.getAttribute("data-ppp") ? generalWrapper.getAttribute("data-ppp") : '',
            offset = generalWrapper.getAttribute("data-offset") ? generalWrapper.getAttribute("data-offset") : '',
            cpt = generalWrapper.getAttribute("data-cpt");
        let filterButton = filtersWrapper.querySelectorAll('.js-filter'),
            e = el.target,
            tax = e.getAttribute("data-tax-id") ? e.getAttribute("data-tax-id") : '',
            data = new URLSearchParams();

        const isReset = e.classList.contains('js-filter-btn-reset');

        filterButton.forEach(button => {
            button.classList.remove('is-active');
        });
        let clearFilters = document.querySelector('#clear-filters'),
            loadMoreButton = document.querySelector('#loadMore');
        clearFilters.classList.add('visible');
        if (isReset) {
            clearFilters.classList.remove('visible');
        }
        el.target.classList.add('is-active');

				resetSearchField();
				resetColorClass();

        data.append('action', 'filter_posts');
        data.append('offset', offset);
        data.append('cpt', cpt);
        data.append('ppp', ppp);
        data.append('tax', tax);
        data.append('taxonomy', taxonomy);
        wrapper.setAttribute('data-tax', tax);
        generalWrapper.setAttribute('data-state', 'filtered');

        axios.post(ajaxurl, data)
            .then(function (response) {
                wrapper.classList.remove('filtering');
                // wrapper.setAttribute('data-page', pageNumber);
                wrapper.innerHTML = response.data['posts'];
                let pages = response.data['pages'];
                generalWrapper.setAttribute('data-pages', pages);
                filtersWrapper.setAttribute('data-tax', tax);

                let pagesNum = parseInt(pages, 10);
                if (pagesNum > pageNumber) {
                    wrapper.setAttribute('data-load-more', 'enabled');
										if(loadMoreButton) {
											loadMoreButton.style.display = "inline-flex";
											loadMoreButton.style.visibility = 'visible';
										}
                } else {
                    wrapper.setAttribute('data-load-more', 'disabled');
										if(loadMoreButton) {
											loadMoreButton.style.display = "none";
											loadMoreButton.style.visibility = 'hidden';
										}
                }
								refreshScrollAndTriggers();
            })
            .catch(function (error) {
                console.log(error);
            });

        if (cpt === 'project') {
            // Check if the clicked element has a 'data-tax-id' attribute
            const filterParam = el.target.getAttribute("data-tax-id");
            const currentURL = new URL(window.location.href);
            if (filterParam) {
                // Add selected filter as a parameter to the page link
                currentURL.searchParams.set('taxonomy', filterParam);
                history.pushState({}, '', currentURL);
            } else {
                currentURL.searchParams.delete('taxonomy');
                history.pushState({}, '', currentURL);
            }
        }
    }

}